module.exports = __webpack_public_path__ + "static/r20-8e00a563c6dd5672ccb62370b92319e6.jpg";